<div class="c100" [ngClass]="classes">
  <span>
    <ng-content></ng-content>
  </span>
  <div class="slice">
      <div class="bar"></div>
      <div class="fill"></div>
  </div>
</div>
